import React from 'react';
import ErrorMessage from '../Common/ErrorMessage';

export default () => {
	return <ErrorMessage>The page you're looking for doesn't exist</ErrorMessage>
};
